import React, { useState } from "react";
import { SdsForm } from "soft_digi";
import { useSiteContext } from "../../contexts/SiteProvider";
import { showAlertAutoClose } from "../../services/notifyService";

import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { SdsFormElementProps } from "soft_digi/dist/sdforms/SdsFromInterFace";
import * as Yup from "yup";

interface HeaderProps {
  dataIn: any;
  saveSettings: (dt: any) => void;
}

const schema = Yup.object({

});

const ExamSettings: React.FC<HeaderProps> = ({ dataIn, saveSettings }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: dataIn,
  });

  const { closeModal } = useSiteContext();

  const hintTitleDisplay = (title: string, hint: string) => {
    return (
      <span>
        {title} <br />
        <small>{hint}</small>
      </span>
    );
  };

  const elements: SdsFormElementProps[] = [
    {
      type: "FILE",
      width: 12,
      name: "exam_left_logo",
      element: {
        label: hintTitleDisplay(
          "Left Exam Logo",
          "Upload the left-side logo for the exam document in PNG or JPEG format."
        ),
        placeHolder: "(Image Only)",
        classList: ["sds-hz-label-30"],
        accept: "*",
        isHorizontal: true,
        size: "small",
      },
    },
    {
      type: "FILE",
      width: 12,
      name: "exam_right_logo",
      element: {
        label: hintTitleDisplay(
          "Right Exam Logo",
          "Upload the right-side logo for the exam document in PNG or JPEG format."
        ),
        placeHolder: "(Image Only)",
        classList: ["sds-hz-label-30"],
        accept: "*",
        isHorizontal: true,
        size: "small",
      },
    },
    {
      type: "TEXT_BOX",
      width: 12,
      name: "exam_title",
      element: {
        label: hintTitleDisplay(
          "Exam Title",
          "Enter the official title of the exam (e.g., Final Semester Exam 2024)."
        ),
        isRequired: true,
        classList: ["sds-hz-label-30"],
        isHorizontal: true,
        size: "small",
      },
    },
    {
      type: "TEXT_BOX",
      width: 12,
      name: "exam_footer",
      element: {
        label: hintTitleDisplay(
          "Exam Footer",
          "Enter the official title of the exam (e.g., Final Semester Exam 2024)."
        ),
        isRequired: true,
        classList: ["sds-hz-label-30"],
        isHorizontal: true,
        size: "small",
      },
    },     {
      type: "TEXT_BOX",
      width: 12,
      name: "exam_massage",
      element: {
        label: hintTitleDisplay(
          "Exam Completed Massage",
          "Enter the official title of the exam (e.g., Final Semester Exam 2024)."
        ),
        isRequired: true,
        classList: ["sds-hz-label-30"],
        isHorizontal: true,
        size: "small",
      },
    },
    {
      type: "BUTTON",
      width: 12,
      name: "submitbutton",
      class_name: "has-text-right",
      element: {
        label: "Save Settings",
        classList: ["smart-action-button"],
      },
    },
  ];

  const onSubmit = (data: any) => {
    saveSettings(data);
    showAlertAutoClose("Exam settings saved successfully!");
    closeModal();
  };

  return (
    <div className="sd-hims-input">
      <form onSubmit={handleSubmit(onSubmit)}>
        <SdsForm elements={elements} errors={errors} control={control} />
      </form>
    </div>
  );
};

export default ExamSettings;
